import { render } from "./SidenavListMenu.vue?vue&type=template&id=6188fcb2"
import script from "./SidenavListMenu.vue?vue&type=script&lang=js"
export * from "./SidenavListMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__